module.exports = __webpack_public_path__ + "media/images/iconbox/icon11-cb3ab4cae1af87aed794a214e2f68dfc.png";